// extracted by mini-css-extract-plugin
module.exports = {"legal":"privacy-policy_legal__A_OKx","hideLinks":"privacy-policy_hideLinks__AWmYw"};